import {useDispatch} from 'store';
import {
  useUIStore,
  hideKeyboard as hideKeyboardAction,
  closeSettings as closeSettingsAction,
  toggleHistory as toggleHistoryAction,
} from 'store/UI';

interface Settings {
  fallbackResponse?: (event?: Message) => void;
}

export function useModalClose(settings: Settings = {}): (event?: Message) => void {
  const {settingsVisible, keyboardVisible, historyVisible} = useUIStore();
  const closeHistory = useDispatch(toggleHistoryAction);
  const hideKeyboard = useDispatch(hideKeyboardAction);
  const closeSettings = useDispatch(closeSettingsAction);

  // eslint-disable-next-line consistent-return
  return (event?: Message): void => {
    if (historyVisible) return closeHistory();
    if (settingsVisible && keyboardVisible) return hideKeyboard();
    if (settingsVisible) return closeSettings();

    const {fallbackResponse: response} = settings;
    if (response) return response(event);
  };
}
